import { useSearchParams } from '@remix-run/react';
import { PIN_TYPE_PARAM_NAME } from '~/modules/design-board/config/design-board-config';
import { DesignBoardPinTargetType } from 'generated/graphql';
import { isValueOfObject } from '~/modules/design-board/util';

const useUrlPinTargetType = (): DesignBoardPinTargetType | undefined => {
    const [searchParams] = useSearchParams();
    const pinTargetType = searchParams.get(PIN_TYPE_PARAM_NAME);
    const isValidPinType = isValueOfObject(
        pinTargetType,
        DesignBoardPinTargetType
    );

    const urlTargetType = isValidPinType
        ? (pinTargetType as DesignBoardPinTargetType)
        : undefined;

    return urlTargetType;
};

export { useUrlPinTargetType };
